import styled from 'styled-components';
import {HOME_PAGE, JACKPOTS_ITEM} from '../../../../themes/css-global-classes';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

//.orbit-swiper-wrapper
const DefaultBox = styled.div`
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0 auto;
    overflow: hidden;
`;

export const PcBox = styled(DefaultBox)`
    .${HOME_PAGE} & {
        width: 90%;
        &.${JACKPOTS_ITEM} {
            width: 100%;
        }
    }
`;

export const MobileBox = styled(DefaultBox)`
    padding: 0;
`;

export const SwiperWrapperDefaultBox = styledByDevice(PcBox, MobileBox);